window.Reverb = window.Reverb || {};

Reverb.BlogSearch = (function () {
  var activeClass = 'search-active',
    userTypingClass = 'user-typing',
    isDesktop = true,
    clickEvent = 'click',

    blogNavigation = '.blog-navigation',
    blogSearch = '.search',
    blogSearchField = '.search input',
    cancelSearchBtn = '.search-cancel';

  function init() {
    clickEvent = Reverb.MobileDetection.getClickEvent();
    isDesktop = !Reverb.MobileDetection.isMobileBrowser();

    $(blogSearch).on(clickEvent, activateSearch);
    $(cancelSearchBtn).on(clickEvent, cancelSearch);
    $(blogSearchField).on('blur', deactivateSearch);
  }

  function activateSearch() {
    var BlogNav = Reverb.MobileNavigation;

    $(blogNavigation).addClass(activeClass);

    if (BlogNav.isMobileDropdownActive()) BlogNav.toggleMobileDropdown();
    if (isDesktop) $(blogNavigation).find(blogSearchField).trigger('focus');
  }

  function deactivateSearch() {
    if ($(blogSearchField).val().length > 0) return false; // stop function
    $(blogNavigation).removeClass(activeClass);
  }

  function cancelSearch() {
    $(blogSearchField).val('').trigger('blur');
  }

  return {
    init: init
  };
})();

$(Reverb.BlogSearch.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/blog/blog_search.js